export default __webpack_public_path__ + "static/media/template-hd4.6b7701bc.png";